import { render } from "./HeroiconsOutlineChevronRight.vue?vue&type=template&id=fdc51454"
const script = {}

import exportComponent from "/Users/dennis/PhpstormProjects/lkm/doc_root/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChevronRight.vue"]])

export default __exports__